<template>
    <div class="container"  v-title="'搜索运动员'">
        <div class="container_content">
            <div class="nav_bar" v-scrollShadow="true">
                <div class="search">
                    <div class="value">
                        <div>
                            <form @submit.prevent="search" action="javascript:return true;">
                                <input type="search" v-model="searchValue" ref="searchValue" placeholder="请输入运动员名称">
                            </form>
                            <YD-image src="icon/icon_search" class="icon"></YD-image>
                        </div>
                        <button class="search_btn" @click="search">搜索</button>
                    </div>
                    <span @click="$navigation.back()">取消</span>
                </div>
                <div class="num">
                    <span>共<i>{{allCount}}</i>个搜索结果</span>
                </div>
            </div>
            <div id="AthleteCertification_search" ref="AthleteCertification_search">
                <Scroll
                    :scroll="roll"
                    @scrollChange="roll = $event"
                    @scrollEnd="scrollEnd"
                >
                    <div class="ACS_content">
                        <ul class="list">
                            <li v-for="(item,index) in list" :key="index" @click="lookOverCertificate(item.CertificateNumber)">
                                <div class="img">
                                    <div class="no_loading">
                                        <img :_src="item.CertificateFile" onerror="this.parentNode.removeChild(this)">
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="level">
                                        <YD-image :src="`athlete_certificate/职工${item.CertificateLevel}级_2`"></YD-image>
                                    </div>
                                    <div class="name">{{item.AthleteName}}</div>
                                    <div class="applicant">{{item.ApplyerName}}</div>
                                </div>
                            </li>
                        </ul>
                        <div class="load_more" v-show="loadMore">
                            <img src="@images/no_data/暂无赛事证书@2x.png" v-show="loadMore == '无数据'">
                            <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                        </div>
                    </div>
                </Scroll>
                <button id="ACS_btn" @click="go()" v-show="ACShow">申请评定</button>
            </div>
        </div>
        <div id="athlete_certificate" v-show="athleteCertificate.show" @click="()=>{athleteCertificate.show = false}">
            <div class="certificate_modal">
                <div class="certificate_content" >
                    <YD-image class="certificate_medal" :src="'athlete_certificate/奖章'+athleteCertificate.AthleteLevel+'级'"></YD-image>
                    <YD-image class="certificate_grade" :src="'athlete_certificate/职工'+athleteCertificate.AthleteLevel+'级'"></YD-image>
                    <ul class="certificate_info">
                        <li>{{athleteCertificate.AthleteName}}</li>
                        <li>{{athleteCertificate.AthleteGender==2?'女':'男'}}</li>
                        <li :class="{'blur': !athleteCertificate.AthleteHasIdentity}">{{athleteCertificate.AthleteMemberNo}}</li>
                        <li>{{athleteCertificate.EventsName}}</li>
                        <li>{{athleteCertificate.SubLeagueName + athleteCertificate.LeagueGroupName + athleteCertificate.MatchScore}}</li>
                    </ul>
                    <div class="certificate_serialNumber">证书编号：{{athleteCertificate.CertificateNumber}}</div>
                    <div class="certificate_date">{{athleteCertificate.CertificateTime | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
            </div>
        </div>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="()=>{tipShow = false}"  @btnCallback="btnCallback"></Alert-tip>
    </div>
</template>
<script>
import {
    GetAthleteCurrentLevelCertificateList,
    GetCompanyList,
    GetAthleteLevelCertificate
} from "@/api"
import appInteraction from "@/common/appInteraction"
export default {
    name: 'AthleteCertificationSearch',
    data() {
        return {
            roll: 0,//滚动距离
            scrollH: 0,
            searchValue: "",
            isValue: true,
            allCount: 0,
            list:[],
            lastId:0,
            loadMore:'',
            isGetData:true,
            ACShow:true,
            athleteCertificate:{},//证书信息
            alertTip:{},
            tipShow:false,
        };
    },
    mounted(){
        var _this = this;
        var oHeight = document.body.offsetHeight;
        window.onresize = function(){
            if(document.body.offsetHeight < oHeight){
                _this.ACShow = false;
            }else{
                _this.ACShow = true;
            }
        }
        this.scrollH = this.$refs['AthleteCertification_search'].offsetHeight;
        setTimeout(()=>{
            this.$refs['searchValue'].focus();
        },300)
    },
    watch:{
        roll:function(scroll, oldScroll){
            if(scroll > oldScroll){
                this.lazyLoading(scroll);
            }
        },
        searchValue:function(){
            this.isValue = true;
        }
    },
    methods: {
        search(){
            if(this.searchValue && this.isValue){
                this.getListData(1);
                this.isValue = false;
                this.$refs['searchValue'].blur();
            }
        },
        scrollEnd(){
            if(!this.isGetData){ 
                return ;
            }
            this.getListData(2,this.lastId);
        },
        getListData(type, lastId){
            if(type == 1){
                this.lastId = 0;
                lastId = 0;
                this.list = [];
            }
            this.isGetData = false;
            this.loadMore = '数据加载中...';
            GetAthleteCurrentLevelCertificateList({
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                },
                EventsId: 0,
                AthleteNameKeyword: this.searchValue,
                CertificateLevel: 0
            }).then(data=>{
                this.isGetData = true;
                this.loadMore = '';
                    console.log(data.Code == 0);
                if(data.Code == 0){
                    this.allCount = data.AllCount;
                    if(!data.ContinuedList || data.ContinuedList.length == 0){
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }else{
                            this.loadMore = '';
                        }
                        this.isGetData = false;
                    }else{
                        if(lastId == 0){
                            this.list = data.ContinuedList;
                        }else{
                            this.list.push.apply(this.list, data.ContinuedList);
                        }
                        this.lastId = data.ContinuedList[data.ContinuedList.length-1].CurrentLevelId;
                        this.$nextTick(function(){
                            this.lazyLoading(this.roll);
                        });
                    }
                }
            }).catch(err=>{
                this.isGetData = true;
                this.loadMore = '';
            })
        },
        lazyLoading(scroll){
            var imgs = document.querySelectorAll('.list .no_loading'); 
            if(imgs.length > 0){
                imgs.forEach((item)=>{
                    let top = item.offsetTop;
                    if(top - scroll < this.scrollH){
                        let src = item.childNodes[0].getAttribute('_src');
                        item.childNodes[0].src = src;
                        item.childNodes[0].removeAttribute('_src');
                        item.childNodes[0].style.display = 'block';
                        item.classList.remove('no_loading');
                    }else{
                        return;
                    }
                })
            }
        },
        lookOverCertificate(CertificateNumber){
            if(!CertificateNumber)return;
            GetAthleteLevelCertificate({
                CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    var obj = data.Certificate;
                    this.athleteCertificate = {
                        show: true,
                        ...obj
                    }
                }
            })
        },
        go(){
            appInteraction.getUserState().then((loginType)=>{
                this.$store.commit('setUserType',loginType);
                if(loginType == 0){
                    this.alertTip = {
                        title:"未登录",
                        text:"您尚未登录机构账户，请先登录",
                        btnArr:["取消","登录"]
                    }
                    this.tipShow = true;
                }else if(loginType == 1){
                    GetCompanyList({IncludeNotAudited:true}).then((data)=>{
                        if(data.Code == 0){
                            if(data.CompanyList.length == 0){
                                this.alertTip = {
                                    title:"未注册",
                                    text:"您尚未注册机构账户，请前往注册",
                                    btnArr:["取消","前往"]
                                }
                            }else{
                                this.alertTip = {
                                    title:"温馨提示",
                                    text: "运动员等级需由机构账户申请，请切换",
                                    btnArr:["取消","切换"]
                                }
                            }
                            this.tipShow = true;
                        }
                    })
                }else if(loginType == 2){
                    this.$navigation.go('/Athletes/AthleteCertification');
                }
            })
        },
        btnCallback(text){
            this.tipShow = false;
            if(text == "取消"){
            }else if(text == "登录"){
                appInteraction.go2Login(2).then(({Type = 0})=>{
                    if(Type == 1){
                        this.$navigation.go('/Account/CompanyManagement');
                    }else if(Type == 2){
                        this.$navigation.go('/Account/AgencyRegistration');
                    }
                })
            }else if(text == "前往"){
                this.$navigation.go('/Account/AgencyRegistration');
            }else if(text == "切换"){
                this.$navigation.go('/Account/CompanyManagement');
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.nav_bar{
    width: 100%;
    height: 160px;
    padding: 8px 40px 0;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    .search{
        height: 72px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .value{
            width: 598px;
            height: 72px;
            background: #FAFBFA;
            border-radius: 36px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px 0 16px;
            box-sizing: border-box;
            >div{
                width: 462px;
                height: 48px;
                position: relative;
                img{
                    width: 48px;
                    height: 48px;
                    position: absolute;
                    top: 0;
                    &.icon{
                        left: 0;
                    }
                }
                form{
                    width: 100%;
                }
                input{
                    width: 100%;
                    height: 48px;
                    padding-left: 56px;
                    box-sizing: border-box;
                    display: block;
                    font-size: 28px;
                    color: #1B1C1E;
                    font-weight: 400;
                }
            }
            .search_btn{
                width: 96px;
                @include line-height(56px);
                background-image: linear-gradient(-48deg, #00C2DC 10%, #29D268 66%, #6ECA09 100%);
                border-radius: 28px;
                font-size: 24px;
                color: #FFFFFF;
                text-shadow: 0 1px 2px #11AD91;
                font-weight: 500;
            }
        }
        >span{
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 400;
        }
    }
    .num{
        height: 72px;
        width: 100%;
        font-size: 26px;
        color: #666666;
        letter-spacing: 0;
        line-height: 40px;
        font-weight: 400;
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::after,
        &::before{
            content:'';
            flex: 1;
            border-bottom:1px #E5E5E5 solid;
        }
        span{
            margin: 0 24px;
        }
        i{
            font-weight: 500;
            color: #1B1C1E;
        }
    }
}
#AthleteCertification_search{
    height: calc(100% - 160px);
    position: relative;
    overflow: hidden;
    .ACS_content{
        padding-bottom: 250px;
    }
    .list{
        width: 100%;
        padding: 24px 40px 0;
        box-sizing: border-box;
        li{
            width: 324px;
            height: 460px;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
            border-radius: 12px;
            margin-bottom: 16px;
            margin-right: 22px;
            display: inline-block;
            vertical-align: middle;
            overflow: hidden;
            &:nth-of-type(2n){
                margin-right: 0;
            }
            .img{
                width: 100%;
                height: 324px;
                padding: 70px 98px 0 96px;
                box-sizing: border-box;
                background-color: #EBF0FA;
                background-image: url('~@images/证书框@2x.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                div,
                img{
                    width: 130px;
                    height: 188px;
                }
                div{
                    background:#D8D8D8;
                }
                img{
                    display: none;
                }
            }
            .info{
                width: 100%;
                padding: 34px 40px 0;
                box-sizing: border-box;
                position: relative;
                text-align: center;
                .level{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: -20px;
                    left: 0;
                    img{
                        width: 128px;
                        height: 40px;
                    }
                }
                .name{
                    width: 100%;
                    font-size: 28px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    text-align: center;
                    @include ellipsis;
                }
                .applicant{
                    width: 100%;
                    font-size: 24px;
                    color: #666666;
                    line-height: 34px;
                    font-weight: 400;
                    text-align: center;
                    margin-top: 8px;
                    @include ellipsis;
                }
            }
        }
    }
    #ACS_btn{
        width: 296px;
        @include line-height(108px);
        background: #1B1C1E;
        box-shadow: 0px 10px 20px 0px rgba(27,28,30,0.25);
        border-radius: 54px;
        font-size: 32px;
        color: #FFFFFF;
        letter-spacing: 6px;
        font-weight: 500;
        position: fixed;
        bottom: 80px;
        left: 50%;
        margin-left: -148px;
    }
}

@include athlete_certificate;
</style>